<nav class="flex items-center position-relative mb-8 mt-16 md:mt-1" *ngIf="(breadcrumbs$ | async) as breadcrumbs">
  <a routerLink="/dashboard" class="mr-3 text-primary">
    <mat-icon
      aria-hidden="false"
      aria-label="Example home icon"
    >
      home
    </mat-icon>
  </a>
  <ol>
    <li
      *ngFor="let breadcrumb of breadcrumbs; let i=index"
      class="inline items-baseline items-center"
      [ngClass]="{'text-lg': i === 0, 'text-muted': i > 0}">
      <span *ngIf="i > 0" class="mx-2 separator">/</span>
      <a *ngIf="i < breadcrumbs.length - 1; else workingRoute" [routerLink]="breadcrumb.url" >
        {{ breadcrumb.displayName }}
      </a>
      <ng-template #workingRoute>
        <span class="text-white">{{ breadcrumb.displayName }}</span>
      </ng-template>
    </li>
  </ol>
</nav>
